import { Percent, Layers, Wallet, LayoutGrid, Headphones } from "lucide-react";
import { useLang } from "../context/LangContext";
import { Reveal } from "./Reveal";

const ICONS = [Percent, Layers, Wallet, LayoutGrid, Headphones];

export const Why = () => {
  const { t } = useLang();
  const c = t.why;

  return (
    <section id="benefits" className="relative py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="mx-auto max-w-2xl text-center">
          <span className="text-xs font-bold uppercase tracking-[0.25em] text-blue-400">{c.tag}</span>
          <h2 className="mt-4 font-display text-3xl font-black text-white sm:text-4xl lg:text-5xl">{c.title}</h2>
        </Reveal>

        <div className="mt-14 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {c.cards.map((card, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal
                key={i}
                delay={i * 0.07}
                className={i >= 3 ? "lg:col-span-1" : ""}
              >
                <div
                  data-testid={`feature-card-${i}`}
                  className={`group relative h-full overflow-hidden rounded-3xl p-7 transition-all duration-500 glass hover:-translate-y-1 hover:border-blue-400/30 ${
                    i === 0 ? "lg:row-span-1" : ""
                  }`}
                >
                  <span className="pointer-events-none absolute -right-3 -top-5 font-display text-7xl font-black text-white/[0.04]">
                    0{i + 1}
                  </span>
                  <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-blue-600/25 to-violet-600/25 text-blue-300 transition-all duration-500 group-hover:shadow-[0_0_24px_rgba(59,130,246,0.4)]">
                    <Icon className="h-6 w-6" />
                  </div>
                  <h3 className="mt-6 font-display text-lg font-extrabold text-white">{card.t}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-slate-400">{card.d}</p>
                </div>
              </Reveal>
            );
          })}
          {/* 5th card: make second row centered nicely on lg (2 cards + spacer keeps grid balanced) */}
          <div className="hidden lg:block" aria-hidden="true" />
        </div>
      </div>
    </section>
  );
};
